import styled from 'styled-components'

import Button from '../Button/Button'

import './hamburgers.css'

const Hamburger = styled(Button).attrs(props => ({
  'aria-label': 'Menu',
  'aria-controls': 'navigation',
}))`
  & .hamburger-inner,
  & .hamburger-inner::before,
  & .hamburger-inner::after,
  &.is-active .hamburger-inner,
  &.is-active .hamburger-inner::before,
  &.is-active .hamburger-inner::after {
    background-color: ${props => props.theme.fontColorWithBackground[props.type]};
  }

  & .hamburger-box {
    width: 20px;
    height: 100%;
  }

  & .hamburger-inner,
  & .hamburger-inner::before,
  & .hamburger-inner::after {
    width: 20px;
    height: 3px;
  }

  & .hamburger-inner::before {
    top: -7px;
  }
  & .hamburger-inner::after {
    bottom: -7px;
  }
`

export default Hamburger
